import React from "react";
import "../../styles/compareWizard.css";

// Header band for the compare wizards: an accent icon chip, title and subtitle,
// with a hairline divider. Replaces the plain <p> modal title.
//   <CompareModalHeader icon={<SwapOutlined />} title="Run ..." subtitle="..." />
function CompareModalHeader({ icon, title, subtitle }) {
  return (
    <div className="cmp-modal-header">
      {icon && <div className="cmp-modal-header-icon">{icon}</div>}
      <div>
        <div className="cmp-modal-header-title">{title}</div>
        {subtitle && <div className="cmp-modal-header-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
}

export default CompareModalHeader;
